import { render } from "./UXfolioBranding.vue?vue&type=template&id=34f60c44"
import script from "./UXfolioBranding.vue?vue&type=script&lang=js"
export * from "./UXfolioBranding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/common/UXfolioBranding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34f60c44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34f60c44', __exports__)) {
    api.reload('34f60c44', __exports__)
  }
  
  module.hot.accept("./UXfolioBranding.vue?vue&type=template&id=34f60c44", () => {
    api.rerender('34f60c44', render)
  })

}


export default __exports__